/*
 * Reloading is how the app picks up a new deployment: index.html is
 * served uncached and points at the current, content-hashed bundles.
 *
 * It lives in its own module so that both the callers (the page error
 * boundary today, the update hint later) go through one place, and so
 * that tests can observe it — jsdom does not let `window.location` be
 * redefined.
 */
export function reloadPage() {
  window.location.reload();
}
